import React from 'react';

import { BrowserRouter as Router, Routes, Route, Navigate,useLocation  } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { useState } from 'react';
import Dashboard from './Dashboard';
import SignUp from './SignUp';
import Home from './Home';
import Login from './Login';
import Showcase from './Showcase';
import ShowcaseSpotify from './ShowcaseSpotify';
import Sidebar from './Sidebar';
import Pronounce from './Pronounce';
import StripeRedirect from './StripeRedirect';
import Settings from './Settings';
import GoLiveBot from './GoLiveBot';
// import NavigationMenu from './NavigationMenu';
import ProtectedRoute from './ProtectedRoute';
import 'swiper/swiper.min.css';
import RequestPasswordReset from './RequestPasswordReset';
import PasswordReset from './PasswordReset';
import GoLiveBotBluesky from './GoLiveBotBluesky';

import './App.css';

function App() {
  const history = createBrowserHistory();



  return (
    <Router history={history}>
      <Routes>
        {/* <Route path={['/dashboard', '/showcase']} element={<NavigationMenu />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/stripeRedirect" element={<StripeRedirect />} />
        <Route path="/dashboard" element={<ProtectedRoute Component={Dashboard} />} />
        <Route path="/showcase" element={<ProtectedRoute Component={Showcase} />} />
        <Route path="/showcasespotify" element={<ProtectedRoute Component={ShowcaseSpotify} />} />
        <Route path="/golivebotbluesky" element={<ProtectedRoute Component={GoLiveBotBluesky} />} />
        <Route path="/golivebot" element={<ProtectedRoute Component={GoLiveBot} />} />
        <Route path="/pronounce" element={<ProtectedRoute Component={Pronounce} />} />
        <Route path="/settings" element={<ProtectedRoute Component={Settings} />} />
        <Route path="/request-password-reset" element={<RequestPasswordReset />} />
        <Route path="/password-reset" element={<PasswordReset />} />

        </Routes>
      {/* <NavigationMenu /> */}
    </Router>
  );
}

export default App;
